export enum frequencyState {
  day = 1,
  week = 2,
  month = 3,
}
type TranslateFn = (key: string) => string

export const frequencyStateLabelI18nKey: Record<frequencyState, string> = {
  [frequencyState.day]: 'remoteAuth.frequencyDay',
  [frequencyState.week]: 'remoteAuth.frequencyWeek',
  [frequencyState.month]: 'remoteAuth.frequencyMonth',
}

export const getFrequencyStateLabel = (t: TranslateFn): Record<frequencyState, string> => ({
  [frequencyState.day]: t(frequencyStateLabelI18nKey[frequencyState.day]),
  [frequencyState.week]: t(frequencyStateLabelI18nKey[frequencyState.week]),
  [frequencyState.month]: t(frequencyStateLabelI18nKey[frequencyState.month]),
})
export enum login_status {
  online = 1,
  offline = 2
}
export const loginStatusLabelI18nKey: Record<login_status, string> = {
  [login_status.online]: 'remoteLoginLog.online',
  [login_status.offline]: 'remoteLoginLog.offline',
}

export const getLoginStatusLabel = (t: TranslateFn): Record<login_status, string> => ({
  [login_status.online]: t(loginStatusLabelI18nKey[login_status.online]),
  [login_status.offline]: t(loginStatusLabelI18nKey[login_status.offline]),
})
export enum Auth_method {
  password = 1,
  auth_code = 2
}
export const authMethodLabelI18nKey: Record<Auth_method, string> = {
  [Auth_method.password]: 'remoteAuth.authPasswordOption',
  [Auth_method.auth_code]: 'remoteAuth.authTokenOption',
}

export const getAuthMethodLabel = (t: TranslateFn): Record<Auth_method, string> => ({
  [Auth_method.password]: t(authMethodLabelI18nKey[Auth_method.password]),
  [Auth_method.auth_code]: t(authMethodLabelI18nKey[Auth_method.auth_code]),
})

export const authMethodLabelSubtitleI18nKey: Record<Auth_method, string> = {
  [Auth_method.password]: 'remoteAuth.authPasswordOptionSubtitle',
  [Auth_method.auth_code]: 'remoteAuth.authTokenOptionSubtitle',
}

export const getAuthMethodLabelSubtitle = (t: TranslateFn): Record<Auth_method, string> => ({
  [Auth_method.password]: t(authMethodLabelSubtitleI18nKey[Auth_method.password]),
  [Auth_method.auth_code]: t(authMethodLabelSubtitleI18nKey[Auth_method.auth_code]),
})

export enum LogType {
  success = 1,
  logout = 2,
  fail = 3,
  auth_success = 4,
  auth_fail = 5
}
export const logTypeLabelI18nKey: Record<LogType, string> = {
  [LogType.success]: 'remoteAuth.logTypeSuccess',
  [LogType.logout]: 'remoteAuth.logTypeLogout',
  [LogType.fail]: 'remoteAuth.logTypeFail',
  [LogType.auth_success]: 'remoteAuth.logTypeAuthSuccess',
  [LogType.auth_fail]: 'remoteAuth.logTypeAuthFail'
}

export const getLogTypeLabel = (t: TranslateFn): Record<LogType, string> => ({
  [LogType.success]: t(logTypeLabelI18nKey[LogType.success]),
  [LogType.logout]: t(logTypeLabelI18nKey[LogType.logout]),
  [LogType.fail]: t(logTypeLabelI18nKey[LogType.fail]),
  [LogType.auth_success]: t(logTypeLabelI18nKey[LogType.auth_success]),
  [LogType.auth_fail]: t(logTypeLabelI18nKey[LogType.auth_fail]),
})
export enum EventType {
  systemLogin = 1,
  remoteLogin = 2,
  authLogin = 3,
}
export const eventTypeLabelI18nKey: Record<EventType, string> = {
  [EventType.systemLogin]: 'remoteAuth.eventTypeSystemLogin',
  [EventType.remoteLogin]: 'remoteAuth.eventTypeRemoteLogin',
  [EventType.authLogin]: 'remoteAuth.eventTypeAuthLogin',
}

export const getEventTypeLabel = (t: TranslateFn): Record<EventType, string> => ({
  [EventType.systemLogin]: t(eventTypeLabelI18nKey[EventType.systemLogin]),
  [EventType.remoteLogin]: t(eventTypeLabelI18nKey[EventType.remoteLogin]),
  [EventType.authLogin]: t(eventTypeLabelI18nKey[EventType.authLogin]),
})
